import { createFileRoute } from "@tanstack/react-router";
import { WaveformPlayer } from "@/components/waveform";

export const Route = createFileRoute("/dev/_devLayout/waveform-test")({
  component: WaveformTest,
});

function WaveformTest() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Reusable Wave Player
          </h1>
          <p className="text-gray-600 text-sm">
            Clean, minimal waveform component
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <WaveformPlayer
            audioUrl="/beat-of-the-music.mp3"
            waveColor="#9CA3AF"
            progressColor="#FF6335"
            height={80}
          />
        </div>

        <div className="mt-6 text-center">
          <p className="text-gray-500 text-xs">
            Built with Wavesurfer.js, React, TypeScript, and Tailwind CSS
          </p>
        </div>
      </div>
    </div>
  );
}
